import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const QuestionCard = (props) => {
  const { title, detail } = props;
  const [showDetial, setShowDEtail] = useState(false);
  return (
    <div className="question-card">
      <div
        className="card-title"
        onClick={() => {
          setShowDEtail(!showDetial);
        }}
      >
        <span>{title}</span>
        <span
          className="card-arrow"
          style={{
            transform: showDetial ? "rotate(0deg)" : "rotate(180deg)",
          }}
        >
          <i className="icon authing-icon authing-arrow-down-line"></i>
        </span>
      </div>
      {showDetial && (
        <div className="card-content">
          {detail.map((item) => (
            <div style={{ marginBottom: 12 }}>{item}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export const PrivateCloudQuestion = ({ title, questions } = {}) => {
  const { t } = useTranslation();
  questions = questions || [
    {
      title: t("solution.privateCloud.question.item1.title"),
      detail: [
        t("solution.privateCloud.question.item1.list1"),
        t("solution.privateCloud.question.item1.list2"),
      ],
    },
    {
      title: t("solution.privateCloud.question.item2.title"),
      detail: [
        t("solution.privateCloud.question.item2.list1"),
        t("solution.privateCloud.question.item2.list2"),
        t("solution.privateCloud.question.item2.list3"),
      ],
    },
    {
      title: t("solution.privateCloud.question.item3.title"),
      detail: [
        t("solution.privateCloud.question.item3.list1"),
        t("solution.privateCloud.question.item3.list2"),
        t("solution.privateCloud.question.item3.list3"),
        t("solution.privateCloud.question.item3.list4"),
        t("solution.privateCloud.question.item3.list5"),
        t("solution.privateCloud.question.item3.list6"),
        t("solution.privateCloud.question.item3.list7"),
        t("solution.privateCloud.question.item3.list8"),
        t("solution.privateCloud.question.item3.list9"),
        t("solution.privateCloud.question.item3.list10"),
        t("solution.privateCloud.question.item3.list11"),
        t("solution.privateCloud.question.item3.list12"),
        t("solution.privateCloud.question.item3.list13"),
      ],
    },
  ];
  return (
    <section className="private-cloud-question">
      <div className="inner">
        <h3 className="block-title">
          {title || t("solution.privateCloud.question.title")}
        </h3>
        {questions.map((item) => (
          <QuestionCard title={item.title} detail={item.detail} />
        ))}
      </div>
    </section>
  );
};
